const API = "https://test.uzloyal.uz/api/"
export default API